<script>
import { filter, find, get } from 'lodash'

export default {
  data() {
    return {
      errors: [],
      errorRootPath: 'form'
    };
  },
  methods: {
    setErrors(errors) {
      this.errors = errors;
    },
    resetErrors() {
      this.setErrors([])
    },
    setError(key, value) {
      return this.errors.push({key, value})
    },
    error(key, defaultValue = null) {
      return this.hasError(key) ? get(find(this.errors, item => item.key === key), 'value', defaultValue) : ''
    },
    errorOrMessage(key, defaultError = null, message = '') {
        return this.hasError(key) ? this.error(key, defaultError) : message
    },
    hasError(key) {
        let localKey = this.errorRootPath + '.' + key
        return !!find(this.errors, item => item.key === key) || get(this.$v, localKey+'.$error')
    },
    anyErrors() {
        this.$v.$touch()
        return this.errors.length || this.$v.$invalid
    },
    type(key) {
      return this.hasError(key) ? 'is-danger' : '';
    },
    touch(key) {
        let localKey = this.errorRootPath + '.' + key
        this.errors = filter(this.errors, item => item.key !== key)
        let func = get(this.$v, localKey+'.$touch')
        typeof func === 'function' && func()
    },
    wrapAction(action) {
        return action.catch((err)=>{
            this.hasError(err)
            throw err
        })
    },
    handleError(err) {
      if (err.response && err.response.data) {
        this.setErrors(err.response.data.errors);
      } else {
        console.log('ERROR:', err);
      }
      const message = err.response.data.message || 'An error occurred';

      this.$buefy.toast.open({
        duration: 5000,
        message: `Oops! ${message}`,
        position: 'is-bottom',
        type: 'is-danger',
      });
    },
  },
};
</script>
